import React from "react";
import "./Invoice.css";
import images from "../../../Utils/importImages";
import AirlineLogos from "./Components/AirlineLogos";
import moment from "moment";

function Invoice({ Data, onClose }) {
  
  console.log("Data her einvbpve is : ", Data);

  const formatPriceWithCommas = (value) => {
    console.log("value si : ", value);

    if (!value) return "0";

    return parseInt(value).toLocaleString("en-IN"); // Use Indian number format
  };


  return (
    <div className="invoice-popup">
      <div className="header">
        <div className="heading proxima_semibold font18 color_black">
          Invoice
        </div>
        <img
          src={images["cross-icon-pop.svg"]}
          alt=""
          srcset=""
          onClick={() => onClose()}
        />
      </div>

      {Data?.filter((item) => item != null && item.data != null).map((item, id) => {
        let mainData = item.data;
        const grandTotal =
          (mainData?.sub_total || 0) +
          (mainData?.markup_value || mainData?.convenience_charges || 0) +
          (mainData?.insurance_charges || 0) -
          (mainData?.less_value || mainData?.discount_charges || 0);
        return (
          <div className="content">
            <div className="invoice-head">
              <div className="head-content">
                <div className="proxima_light color_black font14">
                  Invoice Ref :{" "}
                </div>
                <div className="proxima_semibold color_black font15">
                  {mainData.InvoiceRefNo}
                </div>
              </div>
              <div className="head-content">
                <div className="proxima_light color_black font14">
                  Invoice Date :{" "}
                </div>
                <div className="proxima_semibold color_black font15">
                  {moment(mainData.Date).format("DD MMM, YYYY")}
                </div>
              </div>
              <div className="head-content">
                <div className="proxima_light color_black font14">
                  Booking Id :{" "}
                </div>
                <div className="proxima_semibold color_black font15">
                  {mainData.booking_id}
                </div>
              </div>
            </div>

            <div className="invoice-info">
              <div className="info-card">
                <div className="proxima_light color_black font14">
                  Invoice From :{" "}
                </div>
                <div className="proxima_semibold color_black font15">
                  {mainData.FromInvoice.name}
                </div>
                <div className="proxima_light color_black font15">
                  {mainData.FromInvoice.address}
                </div>
                <div className="document-info">
                  <div className="document">
                    <div className="proxima_semibold color_black font14">
                      GSTIN No:{" "}
                    </div>
                    <div className="proxima_light color_black font15">
                      {mainData.FromInvoice.GSTIN}
                    </div>
                  </div>
                  <div className="document">
                    <div className="proxima_semibold color_black font14">
                      PAN No:{" "}
                    </div>
                    <div className="proxima_light color_black font15">
                      {mainData.FromInvoice.PANNO}
                    </div>
                  </div>
                </div>
              </div>
              <div className="info-card">
                <div className="proxima_light color_black font14">
                  Invoice To :{" "}
                </div>
                <div className="proxima_semibold color_black font15">
                  {mainData.ToInvoice.name}
                </div>
                <div className="proxima_light color_black font15">
                  {mainData.ToInvoice.address}
                </div>
                <div className="document-info">
                  <div className="document">
                    <div className="proxima_semibold color_black font14">
                      GSTIN No:{" "}
                    </div>
                    <div className="proxima_light color_black font15">
                      {mainData.ToInvoice.GSTIN}
                    </div>
                  </div>
                  <div className="document">
                    <div className="proxima_semibold color_black font14">
                      PAN No:{" "}
                    </div>
                    <div className="proxima_light color_black font15">
                      {mainData.ToInvoice.PANNO}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="font18 color_black proxima_semibold">
              BILL DETAILS
            </div>

            {mainData.Data?.map((item, id) => {
              return (
                <div className="content-table" key={id}>
                  <div className="content-head">
                    <div className="content-info">
                      <div className="airline-data">
                        <AirlineLogos
                          length={
                            item.airlinelogos.length == 0
                              ? 1
                              : item.airlinelogos.length
                          }
                          logos={
                            item.airlinelogos.length == 0
                              ? [""]
                              : item.airlinelogos
                          }
                        />
                        <div className="airline-names proxima_regular color_black font14">
                          {item.airlineNames?.join(" , ")}
                        </div>
                      </div>
                      <div className="itenary proxima_semibold color_black font15">
                        <div className="from">{item.journey.from}</div>
                        <img
                          src={images[item.journey.connectIcon]}
                          alt=""
                          srcset=""
                        />
                        <div className="to">{item.journey.to}</div>
                      </div>
                      {item.journey.Via.length > 0 && (
                        <div className="airline-names proxima_regular color_black font14">
                          {item.journey?.Via?.join(" , ")}
                        </div>
                      )}
                    </div>
                    <div className="fare-info">
                      <div className="proxima_light color_black font14">
                        FARE TYPE :
                      </div>
                      <div className="proxima_semibold color_black font15">
                        {item.fareType}
                      </div>
                    </div>
                  </div>
                  <div className="content-row">
                    <div className="data-cell proxima_semibold font15 color_black head width-2">
                      Travellers
                    </div>
                    <div className="data-cell proxima_semibold font15 color_black head width-1-5">
                      Ticket No
                    </div>
                    <div className="data-cell proxima_semibold font15 color_black head width-1">
                      PNR
                    </div>
                    <div className="data-cell proxima_semibold font15 color_black head width-1">
                      Base Fare
                    </div>
                    <div className="data-cell proxima_semibold font15 color_black head width-1">
                      Taxes
                    </div>
                    <div className="data-cell proxima_semibold font15 color_black head width-0-5">
                      Seat
                    </div>
                    <div className="data-cell proxima_semibold font15 color_black head width-1">
                      Meal
                    </div>
                    <div className="data-cell proxima_semibold font15 color_black head width-1">
                      Baggage
                    </div>
                    <div className="data-cell proxima_semibold font15 color_black head width-1">
                      Wheelchair
                    </div>
                    <div className="data-cell proxima_semibold font15 color_black head width-1">
                      Total
                    </div>
                  </div>
                  {item.travellers.map((item, id) => {
                    return (
                      <div className="content-row">
                        <div className="data-cell proxima_regular font14 color_black data width-2">
                          {item.name} ({item.type}){item.isWheelChair ? " ♿" : ""}
                        </div>
                        <div className="data-cell proxima_regular font14 color_black data width-1-5">
                          {item.ticket_number}
                        </div>
                        <div className="data-cell proxima_regular font14 color_black data width-1">
                          {item.pnr}
                        </div>
                        <div className="data-cell proxima_regular font14 color_black data width-1">
                          {formatPriceWithCommas(item.baseFare)}
                        </div>
                        <div className="data-cell proxima_regular font14 color_black data width-1">
                          {formatPriceWithCommas(item.taxes)}
                        </div>
                        <div className="data-cell proxima_regular font14 color_black data width-0-5">
                          {formatPriceWithCommas(item.seat)}
                        </div>
                        <div className="data-cell proxima_regular font14 color_black data width-1">
                          {formatPriceWithCommas(item.meal)}
                        </div>
                        <div className="data-cell proxima_regular font14 color_black data width-1">
                          {formatPriceWithCommas(item.baggage)}
                        </div>
                        <div className="data-cell proxima_regular font14 color_black data width-1">
                          {formatPriceWithCommas(item.wheelchair || 0)}
                        </div>
                        <div className="data-cell proxima_regular font14 color_black data width-1">
                          {formatPriceWithCommas(
                            item?.total ||
                              item.baseFare +
                                item.taxes +
                                item.seat +
                                item.meal +
                                item.baggage +
                                (item.wheelchair || 0)
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              );
            })}

            <div className="content-table">
              <div className="content-row">
                <div className="data-cell proxima_regular font14 color_black data width-2">
                  Sub Total
                </div>
                <div className="data-cell proxima_regular font14 color_black data width-1-5"></div>
                <div className="data-cell proxima_regular font14 color_black data width-1"></div>
                <div className="data-cell proxima_regular font14 color_black data width-1">
                  {formatPriceWithCommas(mainData?.basefare_total || 0)}
                </div>
                <div className="data-cell proxima_regular font14 color_black data width-1">
                  {formatPriceWithCommas(mainData?.taxes_total || 0)}
                </div>
                <div className="data-cell proxima_regular font14 color_black data width-0-5">
                  {formatPriceWithCommas(mainData?.seats_total || 0)}
                </div>
                <div className="data-cell proxima_regular font14 color_black data width-1">
                  {formatPriceWithCommas(mainData?.meals_total || 0)}
                </div>
                <div className="data-cell proxima_regular font14 color_black data width-1">
                  {formatPriceWithCommas(mainData?.baggage_total || 0)}
                </div>
                <div className="data-cell proxima_regular font14 color_black data width-1">
                  {formatPriceWithCommas(mainData?.wheelchair_total || 0)}
                </div>
                <div className="data-cell proxima_regular font14 color_black data width-1">
                  {formatPriceWithCommas(mainData?.sub_total || 0)}
                </div>
              </div>
            </div>
            <div className="sumup-charges">
              <div className="proxima_semibold color_black font14">
                Convenience Charges
              </div>
              <div className="proxima_regular color_black font14 opacity80 sum">
                {formatPriceWithCommas(mainData?.markup_value || mainData?.convenience_charges || 0)}
              </div>
            </div>
            <div className="sumup-charges">
              <div className="proxima_semibold color_black font14">
                Insurance
              </div>
              <div className="proxima_regular color_black font14 opacity80 sum">
                {formatPriceWithCommas(mainData?.insurance_charges || 0)}
              </div>
            </div>
            <div className="sumup-charges">
              <div className="proxima_semibold color_black font14">
                Discount
              </div>
              <div className="proxima_regular color_black font14 opacity80 sum">
                - {formatPriceWithCommas(mainData?.less_value || mainData?.discount_charges || 0)}
              </div>
            </div>
            <div className="content-table">
              <div className="content-row">
                <div className="data-cell proxima_semibold font14 color_black data width-2">
                  Grand Total
                </div>
                <div className="data-cell proxima_regular font14 color_black data width-1-5"></div>
                <div className="data-cell proxima_regular font14 color_black data width-1"></div>
                <div className="data-cell proxima_regular font14 color_black data width-1"></div>
                <div className="data-cell proxima_regular font14 color_black data width-1"></div>
                <div className="data-cell proxima_regular font14 color_black data width-0-5"></div>
                <div className="data-cell proxima_regular font14 color_black data width-1"></div>
                <div className="data-cell proxima_regular font14 color_black data width-1"></div>
                <div className="data-cell proxima_regular font14 color_black data width-1"></div>
                <div className="data-cell proxima_semibold font14 color_black data width-1">
                  {formatPriceWithCommas(grandTotal)}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default Invoice;
